"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calvanico": {
    "470a17c0": [{
      "hkey": "1ec6824f",
      "slug": "calvanico",
      "name": "Calvanico",
      "primary": true,
      "skipSearch": false
    }],
    "capo-calvanico": [{
      "hkey": "1ec6824f",
      "slug": "calvanico",
      "name": "Calvanico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25e838f7": [{
      "hkey": "1ec6824f",
      "slug": "calvanico",
      "name": "Calvanico",
      "primary": true,
      "skipSearch": false
    }],
    "mezzina": [{
      "hkey": "1ec6824f",
      "slug": "calvanico",
      "name": "Calvanico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4119a4b1": [{
      "hkey": "1ec6824f",
      "slug": "calvanico",
      "name": "Calvanico",
      "primary": true,
      "skipSearch": false
    }],
    "pie-di-calvanico": [{
      "hkey": "1ec6824f",
      "slug": "calvanico",
      "name": "Calvanico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;